import React, { useState } from 'react'
import { Popover, Link, ActionButton, Icon, Overlay } from 'ui'
import styles from '@styles/components/FireflyPaidExhaustableNotification.module.scss'
import { useMediumMinimumSizePreference } from '@hooks/useProject'
import { useTranslations } from 'use-intl'
import GenerativeCreditsIcon from '/public/s2_icon_generative_credits.svg'

export function FireflyPaidExhaustableNotification() {
  const t = useTranslations()

  const [isOpen, setIsOpen] = useState(false)

  const size = useMediumMinimumSizePreference()

  return (
    <>
      <ActionButton
        size={size}
        quiet
        id="firefly-paid-exhaustable-notification-trigger"
      >
        <Icon slot="icon">
          <GenerativeCreditsIcon />
        </Icon>
      </ActionButton>

      <Overlay
        open={isOpen}
        spOpened={() => setIsOpen(true)}
        spClosed={() => setIsOpen(false)}
        trigger="firefly-paid-exhaustable-notification-trigger@click"
        placement="top"
      >
        <Popover className={styles['popover']}>
          <h6>
            {t('studio:firefly:notification:paid-exhaustable-user:header')}
          </h6>
          <p>{t('studio:firefly:notification:paid-exhaustable-user:body')}</p>
          {t.rich('studio:firefly:notification:paid-exhaustable-user:link', {
            hyperlinked: chunks => (
              <Link
                href="https://helpx.adobe.com/firefly/get-set-up/learn-the-basics/generative-credits-overview.html"
                target="_blank"
              >
                {chunks}
              </Link>
            )
          })}
        </Popover>
      </Overlay>
    </>
  )
}
